module Client.LocationEquipments


open Client
open Client.Services
open Shared
open global.Elmish
open System
open Thoth.Fetch
open Thoth.Json
open Fetch.Types
open Feliz
open Feliz.MaterialUI
open Fable.MaterialUI.Icons
open Fable.MaterialUI.MaterialDesignIcons
open Feliz.UseElmish
open Fable.Core.Experimental
open System.Text.RegularExpressions
// open Fable.Core.JS

let renderBreadcrumbs customerId =
  Mui.breadcrumbs [
    breadcrumbs.children [
      Mui.link [
        prop.href (Client.Pages.toHash Pages.Page.Home)
        link.children "Home"
      ]
      Mui.link [
        prop.href (Client.Pages.toHash Pages.Page.Locations)
        link.children "Locations"
      ]
      Mui.link [
        prop.href (Client.Pages.toHash (Pages.Page.Location customerId))
        link.children "Location"
      ]
      Mui.typography [
        typography.color.textPrimary
        typography.children "Equipment"
      ]
    ]
  ]

let view = React.functionComponent (fun (inputProps: {| customerId : int; model : LoggedInModel; |}) ->
  let classes = Styles.useStyles ()
  let (equipment, setEquipment) = React.useState(Array.empty<Shared.Equipment>)
  let (error, setError) = React.useState<string option>(None)
  let (isLoading, setIsLoading) = React.useState(true)

  React.useEffectOnce(fun () ->
    promise {
      let! authHeader = Services.getAuthHeader()
      try
        let decoder = Services.decoder<Shared.Equipment []>
        let! response = Fetch.tryGet($"/api/Location/%i{inputProps.customerId}/Equipment", headers = [ authHeader ], decoder = decoder)
        match response with
        | Ok v ->
          setEquipment v
        | Result.Error fetchError ->
          match fetchError with
          | FetchError.DecodingFailed _ -> setError (Some "Problem parsing response")
          | FetchError.FetchFailed msg -> setError (Some "Problem fetching equipment")
          | FetchError.NetworkError _ -> setError (Some "Problem fetching equipment")
          | FetchError.PreparingRequestFailed _ -> setError (Some "Problem fetching equipment")
      with e ->
        setError (Some e.Message)
      setIsLoading false
    } |> ignore
  )

  Html.div [
    renderBreadcrumbs inputProps.customerId
    Html.h2 "Equipment"
    if isLoading then
      Mui.circularProgress []
    else
      match error with
      | Some msg -> Html.p [ prop.style [ style.color.red ]; prop.text msg ]
      | None ->
        if Array.isEmpty equipment then
          Html.p "No equipment found"
        else
          Html.div [
            Html.p "Choose a piece of equipment from the following list."
            Mui.list [
              prop.width 100
              list.children [
                for x in equipment do
                  Mui.listItem [
                    listItem.alignItems.flexStart
                    listItem.button true
                    listItem.component' "a"
                    prop.href (Client.Pages.toHash (Pages.Page.LocationEquipment (inputProps.customerId,x.Id)))
                    listItem.children [
                      Mui.listItemText [
                        listItemText.primary (sprintf "Equipment: %s" x.EquipmentNumber)
                        listItemText.secondary [
                          Mui.typography [
                            typography.variant.body2
                            typography.color.textSecondary
                            prop.text (sprintf "Serial: %s" x.SerialNumber)
                          ]
                          Mui.typography [
                            typography.variant.body2
                            typography.color.textSecondary
                            prop.text (sprintf "Location: %s" x.Location)
                          ]
                        ]
                      ]
                      // Mui.listItemSecondaryAction [
                      //   listItemSecondaryAction.children [
                      //     Mui.iconButton [
                      //       iconButton.edge.start
                      //       iconButton.children [ expandMoreIcon [ ]]
                      //       prop.ariaLabel "Edit"
                      //     ]
                      //   ]
                      // ]

                    ]
                  ]
              ]
            ]
          ]
  ]
)
